import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  getTeam: false,
  updatePermission: false,
  updateTeam: false,
  updateTeamInSeason: false,
  getFirstBaseGamesInSeason: false,
};

const Team = {
  getTeam: ({ teamUniqid }) => {
    if (debugStatus.getTeam) {
      return fakeApiHelper(200, 'success', {
        data: {
          cover_path: '',
          cover_url: '',
          description: '',
          experiences: [
            {
              season: '2020 北區高中棒球聯會夏季聯賽',
              season_uniqid: 'nH8l-2020-Sc',
              season_year: 2020,
              team: '成功高中',
            },
            {
              season: '2021 北區高中棒球聯會冬季聯賽',
              season_uniqid: 'nH8l-2021-23',
              season_year: 2021,
              team: '成功高中',
            },
          ],
          social_media: {},
          icon_path: '/t/57Xo/icon/1618368404-jCI8dNKa4V',
          icon_url: 'https://storage.googleapis.com/dev-rebas/t/57Xo/icon/1618368404-jCI8dNKa4V',
          name: '成功高中',
          uniqid: '57Xo',
        },
        error: false,
        message: 'Get team successfully',
      });
    }

    return ApiService.get(`/api/teams/${teamUniqid}`);
  },

  updatePermission: ({ userUniqid, teamUniqid, authority }) => {
    if (debugStatus.updatePermission) {
      return fakeApiHelper(200, 'success', {
        data: {
          permission: 'ADMIN',
        },
        error: false,
        message: 'Request successfully',
      });
    }

    return ApiService.put(`/api/users/${userUniqid}/permission/team/${teamUniqid}`, { data: { authority } });
  },

  updateTeam: ({ teamUniqid, data }) => {
    if (debugStatus.updateTeam) {
      return fakeApiHelper(200, 'success', {
        data: {
          experiences: [],
          icon_path: '',
          icon_url: '',
          name: 'AAAA',
          uniqid: 'wxyz',
        },
        error: false,
        message: 'Update team successfully',
      });
    }

    return ApiService.put(`/api/teams/${teamUniqid}`, { data });
  },

  updateTeamInSeason: ({ teamUniqid, seasonUniqid, teamName, data }) => {
    if (debugStatus.updateTeamInSeason) {
      return fakeApiHelper(200, 'success', {
        data: {
          name: 'AAAA B',
          origin: {
            icon_url: '',
            name: 'AAAA',
            uniqid: 'wxyz',
          },
          season: { title: '2020 OOOO', uniqid: 'wasd' },
        },
        error: false,
        message: 'Update season team successfully',
      });
    }

    return ApiService.put(`/api/teams/${teamUniqid}/seasons/${seasonUniqid}/teams/${encodeURIComponent(teamName)}`, {
      data,
    });
  },

  getFirstBaseGamesInSeason: ({ seasonUniqid, seasonTeamUniqid }) => {
    return ApiService.get(`/api/seasons/${seasonUniqid}/firstbase/teams/${seasonTeamUniqid}/games`);
  },
};

export default Team;
